import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:radiuses');

export default class RadiusesService {
  constructor(aas, cs) {
    this.adApiService = aas;
    this.clusterService = cs;
    this.radiuses = null;
    this.radiusDefault = {
      default: [0],
    };
  }

  loadRadiusesFromApi() {
    debug.info('loading from api');
    return this.adApiService.getRadiuses()
      .then(res => {
        Object.keys(res.online).forEach(type => {
          const radiuses = [];
          (res.online)[type].forEach(r => {
            if (r.from && r.to) {
              for (let i = r.from; i <= r.to; i += 1) {
                radiuses.push(i);
              }
            } else {
              radiuses.push(r);
            }
          });
          (res.online)[type] = radiuses;
        });
        return Object.assign({}, this.radiusDefault, (res));
      })
      .catch((err) => {
        debug.error('error: %o', err);
        return [];
      })
      .then((radiuses) => {
        debug.info('success: %j', radiuses);
        this.radiuses = radiuses;
        return radiuses;
      });
  }

  getRadiuses() {
    if (this.radiuses === null) {
      return this.loadRadiusesFromApi();
    }

    return new Promise(resolve => resolve(this.radiuses));
  }
}

Injector.service('radiusesService', ['adApiService', 'clusterService'], RadiusesService);



// WEBPACK FOOTER //
// ./src/services/RadiusesService.js